import React, { FC } from "react";
import { theme } from "../../../config";
import { ApplicantDetailsModalFooter } from "../ApplicantDetailsModalFooter";
import { MoveApplicantStatusDetails } from "../MoveApplicantStatusDetails";

type Props = {
  applicantName: string;
  fromStatus: string;
  toStatus: string;
  fromStatusColor?: string;
  toStatusColor?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmationModalBody: FC<Props> = ({
  applicantName,
  fromStatus,
  toStatus,
  fromStatusColor,
  toStatusColor,
  onConfirm,
  onCancel,
}) => {
  return (
    <>
      <MoveApplicantStatusDetails
        applicantName={applicantName}
        tag1Color={fromStatusColor || theme.colors.custom.darkblue1}
        tag1Text={fromStatus}
        tag2Color={toStatusColor || theme.colors.custom.darkblue3}
        tag2Text={toStatus}
      />
      <ApplicantDetailsModalFooter onConfirm={onConfirm} onCancel={onCancel} />
    </>
  );
};

export default ConfirmationModalBody;
